import { render, staticRenderFns } from "./CameraButtonAppend.vue?vue&type=template&id=574dede3&scoped=true"
import script from "./CameraButtonAppend.vue?vue&type=script&lang=js"
export * from "./CameraButtonAppend.vue?vue&type=script&lang=js"
import style0 from "./CameraButtonAppend.vue?vue&type=style&index=0&id=574dede3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "574dede3",
  null
  
)

export default component.exports